import React from 'react';
import PropTypes from "prop-types";


const DriverName = ({ children }) => (
  <span>
    {children}
  </span>
);

DriverName.propTypes = {
  children: PropTypes.node,
};

export default DriverName;
